import React, { useEffect, useState } from "react";

const links = [
  { id: "about", label: "About", num: "01" },
  { id: "approach", label: "Approach", num: "02" },
  { id: "brutal-design", label: "Project", num: "03" },
  { id: "gallery", label: "Gallery", num: "04" },
  { id: "contact", label: "Contact", num: "05" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <span className="font-mono text-[10px] tracking-[0.4em] text-[#a3a3a3] group-hover:text-white transition-colors">
            R / B
          </span>
          <span className="hidden md:inline-block w-8 h-px bg-white/30 group-hover:bg-[#c01515] transition-colors" />
          <span className="hidden md:inline font-display text-xl tracking-tight">
            Ranjana Baruah
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="nav-link flex items-center gap-2"
            >
              <span className="text-[#990F0F]">{l.num}</span>
              <span>{l.label}</span>
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => scrollTo("contact")}
          className="hidden md:inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-white border border-white/20 px-4 py-2 hover:bg-white hover:text-black transition-all"
        >
          Initiate
        </button>

        {/* mobile dot indicator */}
        <button
          data-testid="header-mobile-cta"
          onClick={() => scrollTo("contact")}
          className="md:hidden font-mono text-[10px] tracking-[0.3em] uppercase border border-white/20 px-3 py-2"
        >
          Hi
        </button>
      </div>
    </header>
  );
}
